/**
 * Hands a generated file to the browser as a download. The anchor is attached while it is clicked (some browsers ignore a detached one) and the
 * object URL is released only after a delay: revoking it at once can cancel a large download before the browser has read it.
 */
export function downloadBlob(blob: Blob, filename: string, revokeAfterMs = 30_000): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.hidden = true
  document.body.append(anchor)
  anchor.click()
  anchor.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), revokeAfterMs)
}

export const readableSize = (bytes: number): string => bytes < 1024 ? `${bytes} B` : bytes < 1024 * 1024 ? `${Math.round(bytes / 1024)} kB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`
